import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useProjectLoader } from "@repo/shared-project/hooks/ProjectLoaderHook";
import { createEmptyProject } from "@repo/shared-project/types/ProjectTypes";

import { ProjectEdit } from "./ProjectEdit";

import type { RuleFactoryType } from "@repo/server-api/types";
import type { Project } from "@repo/shared-project/types/ProjectTypes";

export const ProjectEditPage = (props: { ruleFactory: RuleFactoryType }) => {
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();

	const { project, loading } = useProjectLoader(id);

	const [localProject, setLocalProject] = useState<Project>(createEmptyProject());

	useEffect(() => {
		if (project) {
			setLocalProject(project);
		}
	}, [project]);

	return (
		<Box
			style={{
				minHeight: "90vh",
				height: "auto",
				width: "100%",
				position: "relative",
			}}>
			{loading ? (
				<Box display="flex" justifyContent="center" alignItems="center" height="100vh">
					<CircularProgress />
				</Box>
			) : project && localProject ? (
				<ProjectEdit
					project={localProject}
					setProject={setLocalProject}
					rulefactory={props.ruleFactory}
				/>
			) : (
				<Box textAlign="center">
					<Typography variant="h6">{t("nothing-available")}</Typography>
				</Box>
			)}
		</Box>
	);
};
